import apiClient from "./client";
import type {
  DisasterIdParam,
  DisasterStatusUsersResponse,
  GetDisasterStatusUsersParams,
} from "../types/disaster";

export const getDisasterStatusUsers = async (
  disasterId: DisasterIdParam,
  params: GetDisasterStatusUsersParams
): Promise<DisasterStatusUsersResponse> => {
  const { data } = await apiClient.get<DisasterStatusUsersResponse>(
    `/disaster-status-users/${disasterId}`,
    {
      params: {
        disaster_id: params.disaster_id,
        role_id: params.role_id,
        disaster_status_ids: params.disaster_status_ids,
      },
    }
  );
  return data;
};
